/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * The kind of control valve.
 */
export const AnimaticControlValveConfigKind = {
  Motorized: "motorized",
  Icad: "icad",
  Pneumatic: "pneumatic",
  King: "king",
} as const;
/**
 * The kind of control valve.
 */
export type AnimaticControlValveConfigKind = OpenEnum<
  typeof AnimaticControlValveConfigKind
>;

/**
 * Optional value variant for applicable control valves (forwarded to process-view valve when mapped).
 */
export const AnimaticControlValveConfigVariant = {
  AB: "A-B",
  BC: "B-C",
  AC: "A-C",
  Default: "default",
} as const;
/**
 * Optional value variant for applicable control valves (forwarded to process-view valve when mapped).
 */
export type AnimaticControlValveConfigVariant = OpenEnum<
  typeof AnimaticControlValveConfigVariant
>;

/**
 * The configuration of the animatic for a control valve.
 */
export type AnimaticControlValveConfig = {
  /**
   * The kind of control valve.
   */
  kind: AnimaticControlValveConfigKind;
  /**
   * A reference to a reading or setting.
   */
  valueRef?: Ref | undefined;
  /**
   * Optional value variant for applicable control valves (forwarded to process-view valve when mapped).
   */
  variant?: AnimaticControlValveConfigVariant | undefined;
};

/** @internal */
export const AnimaticControlValveConfigKind$inboundSchema: z.ZodType<
  AnimaticControlValveConfigKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticControlValveConfigKind);
/** @internal */
export const AnimaticControlValveConfigKind$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticControlValveConfigKind
> = openEnums.outboundSchema(AnimaticControlValveConfigKind);

/** @internal */
export const AnimaticControlValveConfigVariant$inboundSchema: z.ZodType<
  AnimaticControlValveConfigVariant,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticControlValveConfigVariant);
/** @internal */
export const AnimaticControlValveConfigVariant$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticControlValveConfigVariant
> = openEnums.outboundSchema(AnimaticControlValveConfigVariant);

/** @internal */
export const AnimaticControlValveConfig$inboundSchema: z.ZodType<
  AnimaticControlValveConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  kind: AnimaticControlValveConfigKind$inboundSchema,
  value_ref: types.optional(Ref$inboundSchema),
  variant: types.optional(AnimaticControlValveConfigVariant$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "value_ref": "valueRef",
  });
});
/** @internal */
export type AnimaticControlValveConfig$Outbound = {
  kind: string;
  value_ref?: Ref$Outbound | undefined;
  variant?: string | undefined;
};

/** @internal */
export const AnimaticControlValveConfig$outboundSchema: z.ZodType<
  AnimaticControlValveConfig$Outbound,
  z.ZodTypeDef,
  AnimaticControlValveConfig
> = z.object({
  kind: AnimaticControlValveConfigKind$outboundSchema,
  valueRef: Ref$outboundSchema.optional(),
  variant: AnimaticControlValveConfigVariant$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    valueRef: "value_ref",
  });
});

export function animaticControlValveConfigToJSON(
  animaticControlValveConfig: AnimaticControlValveConfig,
): string {
  return JSON.stringify(
    AnimaticControlValveConfig$outboundSchema.parse(animaticControlValveConfig),
  );
}
export function animaticControlValveConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticControlValveConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticControlValveConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticControlValveConfig' from JSON`,
  );
}
